import React from "react";
import Dropdown from "react-bootstrap/lib/Dropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";

const SuggestionsDropdown = ({ onSelect, suggestions = [], toggle, active, styles = {} }) => {
  const renderSuggestions = () => {
    if (suggestions.length) {
      return suggestions.map(({ value, text }) => (
        <MenuItem
          key={`drop-down-suggestion-${text}`}
          eventKey={value}
          className="dropdown-item text-decoration-none py-2 px-3"
        >
          {text}
        </MenuItem>
      ));
    } else {
      return (
        <MenuItem eventKey={null}>
          <span className="no-suggestions">No Suggestions</span>
        </MenuItem>
      );
    }
  };

  const onToggle = (isOpen, _event, { source }) => {
    !isOpen && source === "rootClose" && toggle();
  };

  return (
    <Dropdown
      id="suggestions-dropdown"
      className={`${styles.suggestionsDropdown}`}
      defaultOpen={false}
      open={active}
      onToggle={onToggle}
      onSelect={onSelect}
    >
      <Dropdown.Menu>{renderSuggestions()}</Dropdown.Menu>
    </Dropdown>
  );
};

export default SuggestionsDropdown;
